module.exports = __webpack_public_path__ + "img/tg.15f9e852.png";